import { Space, Table, Checkbox } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { getModifieresForItem } from "../../../../api/itemModifiers";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Specification } from "./Item";
interface DataType {
  isComponent: boolean;
  specificationId: number;
  id: number;
  extraCharge: number;
  quantity: number;
  notes: string;
}
interface Props {
  selectedItem: any;
  specifications: Specification[];
  setSpecifications: Dispatch<SetStateAction<Specification[]>>;
}

export const Toppings = ({
  selectedItem,
  specifications,
  setSpecifications,
}: Props) => {
  const [formatedToppings, setFormatedToppings] = useState<DataType[]>();
  const { isLoading, mutateAsync: itemToppingsMutation } = useMutation(
    "toppings",
    () => getModifieresForItem(selectedItem?.itemId)
  );
  useEffect(() => {
    itemToppingsMutation().then((res) => {
      setFormatedToppings(
        res?.data.map((topping: any) => {
          return {
            toppings: topping?.modifier?.name,
            isComponent: false,
            specificationId: topping.id,
            id: topping?.modifier?.id,
            extraCharge: topping.price,
            quantity: 1,
            notes: "Example specification notes",
          };
        })
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  //const dispatch = useDispatch();
  //const selectedItem = useSelector((state: any) => state.main.selectedItem);
  const [t] = useTranslation("common");
  const columns: ColumnsType<DataType> = [
    {
      title: `${t("toppings")}`,
      dataIndex: "toppings",
      key: "toppings",
      className: "table-header",
    },
    {
      title: `${t("extra-charge")}`,
      dataIndex: "extraCharge",
      key: "extraCharge",
      render: (record) => {
        return (
          <div style={{ color: "#A7A7A7", textAlign: "center" }}>
            {record} $
          </div>
        );
      },
    },
    {
      title: `${t("select")}`,
      key: "select",
      render: (record) => (
        <Space size="middle">
          <Checkbox
            defaultChecked={selectedItem.specifications.some(
              (specification: DataType) =>
                specification.id === record.id &&
                specification.isComponent === record.isComponent
            )}
            onClick={() => {
              const isIdInArray = specifications?.some((topping: any) => {
                return (
                  topping.id === record.id &&
                  topping.isComponent === record.isComponent
                );
              });
              if (isIdInArray) {
                setSpecifications(
                  specifications.filter((spec: any) => spec.id !== record.id)
                );
              } else {
                setSpecifications([
                  ...specifications,
                  {
                    isComponent: record.isComponent,
                    specificationId: record.specificationId,
                    id: record.id, /// orginal id
                    extraCharge: record.extraCharge,
                    quantity: record.quantity,
                    notes: record.notes,
                  },
                ]);
              }
            }}
          />
        </Space>
      ),
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={formatedToppings}
        pagination={false}
        loading={isLoading}
        rowKey={(record) => record.specificationId}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
      />
    </>
  );
};
